//src/hooks/useApiCall.ts
import { useState, useCallback } from 'react';
import { apiGet, apiPost, apiPut, apiDelete } from '../services/api'; // Importa as funções existentes de api.ts
import axios from 'axios';

interface ApiOptions {
  onSuccess?: (data: any) => void;   // Callback opcional chamado após sucesso
  onError?: (error: any) => void;     // Callback opcional chamado em caso de erro
}

/**
 * Hook reutilizável para chamadas API que precisam de controle de loading.
 * Mantém api.ts como única fonte de requisições HTTP.
 */
export const useApiCall = () => {
  const [isLoading, setIsLoading] = useState(false); // Estado de loading compartilhado
  const [error, setError] = useState<string | null>(null); // Estado de erro (opcional)

  const callApi = useCallback(
    async (
      method: 'get' | 'post' | 'put' | 'delete',
      endpoint: string,
      body?: any,
      options?: ApiOptions
    ) => {
      setIsLoading(true);   // Ativa loading automaticamente
      setError(null);

      try {
        let response;
        // Reusa exatamente as funções de api.ts
        switch (method) {
          case 'get':
            response = await apiGet(endpoint);
            break;
          case 'post':
            response = await apiPost(endpoint, body);
            break;
          case 'put':
            response = await apiPut(endpoint, body);
            break;
          case 'delete':
            response = await apiDelete(endpoint); 
          break;
          default:
            throw new Error('Método inválido');
        }

        options?.onSuccess?.(response.data); // Executa callback de sucesso, se fornecido
        return response.data;
      } catch (err) {
        // Extrai mensagem de erro amigável (mesmo padrão usado em outros componentes)
        const message = axios.isAxiosError(err) ? err.response?.data?.error || 'Erro na chamada API' : 'Erro desconhecido';
        setError(message);
        options?.onError?.(err);
        throw err; // Repropaga para tratamento local, se necessário
      } finally {
        setIsLoading(false); // Desativa loading sempre, mesmo em erro
      }
    },
    []
  );

  return { callApi, isLoading, error };
};